import { SelectInput } from '@framework/form';
import React from 'react';
import { useExtraEuCountryCode } from '../country-codes/useExtraEuCountryCode';

export interface IHomeCountrySelectProps {
  name: string;
}

export function HomeCountrySelect(props: IHomeCountrySelectProps) {
  const { name } = props;
  const { options: countrySelectOptions } = useExtraEuCountryCode();

  return (
    <SelectInput
      name={name}
      options={countrySelectOptions}
      showSearch
      optionFilterProp="label"
    />
  );
}
